import { isRetryableAssistantError } from "@earendil-works/pi-ai";

const OUT_OF_CREDIT = /insufficient_quota|out of budget|quota exceeded|billing|payment required|requires more credits|\b402\b/i;
const CREDENTIALS = /unauthorized|forbidden|invalid.?api.?key|authentication|\b401\b|\b403\b/i;
const RATE_LIMITED = /rate.?limit|too many requests|\b429\b/i;
const CONTEXT_TOO_LONG = /maximum context length|context_length_exceeded|prompt is too long|context window/i;
const REJECTED = /invalid_request|\b400\b/i;
const BROWSER_DROP = /failed to fetch|load failed|network connection was lost|connection closed/i;
// The stream runtime's own wording for a call it abandoned after the provider
// went quiet and could not get past on retry (piStreamFn.js).
const STALLED = /no response from the model provider for \d+ seconds/i;

const GENERIC = "The model run did not finish.";

export function isTransientLlmFailure(message) {
    if (message?.stopReason !== "error") return false;
    const text = String(message?.errorMessage ?? "");
    if (!text || OUT_OF_CREDIT.test(text) || CREDENTIALS.test(text)) return false;
    return BROWSER_DROP.test(text) || isRetryableAssistantError(message);
}

export function llmErrorCopy(raw) {
    const detail = String(raw ?? "").trim();
    if (!detail) return { message: GENERIC, detail: "" };
    if (OUT_OF_CREDIT.test(detail)) {
        return { message: "This account is out of model credit. Top it up and run this again.", detail };
    }
    if (CREDENTIALS.test(detail)) {
        return { message: "The model provider rejected our credentials. Check the provider key in Settings.", detail };
    }
    if (RATE_LIMITED.test(detail)) {
        return { message: "The model provider is rate limiting us. Wait a moment and run this again.", detail };
    }
    if (STALLED.test(detail)) {
        return { message: "The model provider stopped responding partway through. Try running it again.", detail };
    }
    if (isTransientLlmFailure({ stopReason: "error", errorMessage: detail })) {
        return {
            message: "The connection to the model provider dropped before it finished answering. Try running it again.",
            detail,
        };
    }
    if (CONTEXT_TOO_LONG.test(detail)) {
        return { message: "This conversation is too long for the model. Start a new chat to continue.", detail };
    }
    if (REJECTED.test(detail)) {
        return { message: "The model provider rejected the request.", detail };
    }
    return { message: GENERIC, detail };
}
